<script>
  import { createEventDispatcher } from "svelte";
  import File from "./File.svelte";
  import {
    getIconForFile,
    getIconForFolder,
    getIconForOpenFolder
  } from "vscode-icons-js";
  export let expanded = false;
  export let name;
  export let children;
  export let path;
  export let size;
  export let type;
  const dispatch = createEventDispatcher();
  const displayContent = path => {
	   dispatch("displayContent2", "");
  };

  function toggle() {
    expanded = !expanded;
  }
</script>

<style>
  span {
    padding: 0 0 0 1.5em;
    background: url(tutorial/icons/folder.svg) 0 0.1em no-repeat;
    background-size: 1em 1em;
    font-weight: bold;
    cursor: pointer;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    overflow-y: auto;
    overflow-x: hidden;
    font-size: smaller;
  }

  .expanded {
    background-image: url(tutorial/icons/folder-open.svg);
  }

  ul {
    padding: 0 0 0 0.5em;
    margin: -0.2em 0 -0.2em 0.5em;
    list-style: none;
    border-left: 1px solid #eee;
  }

  li {
    padding: 0 0;
    margin: -0.2em 0;
  }
</style>

<span
  style="background-image:url('./icons/{expanded ? getIconForOpenFolder(name) : getIconForFolder(name)}');white-space: nowrap;overflow: hidden;text-overflow: clip;"
  class:expanded
  title={name}
  on:click={toggle}>
   {name}
</span>

{#if expanded}
  <ul>
    {#each children as file}
      <li>
        {#if file.type === 'directory'}
          <svelte:self {...file} />
        {:else}
          <File {...file} on:displayContent={displayContent} />
        {/if}
      </li>
    {/each}
  </ul>
{/if}
